module.exports = __webpack_public_path__ + "img/main-facility-golf-tang.6efb30c7.jpg";